import { render, staticRenderFns } from "./VerifiedAnomaliesTable.vue?vue&type=template&id=226e674c"
import script from "./VerifiedAnomaliesTable.vue?vue&type=script&lang=js"
export * from "./VerifiedAnomaliesTable.vue?vue&type=script&lang=js"
import style0 from "./VerifiedAnomaliesTable.vue?vue&type=style&index=0&id=226e674c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports